module.exports = __webpack_public_path__ + "img/maria-dommer.e17e383d.jpg";